import React, { useRef } from "react";
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";

export const ImageCropper = ({ src, cropperRef }) => {
    const initalZoomLevelRef = useRef(null);
    const onReady = () => {
        const cropper = cropperRef.current?.cropper;
        const image = cropper?.image;
        const container = cropper?.getContainerData();

        if (image && container) {
            const imageWidth = image.naturalWidth;
            const imageHeight = image.naturalHeight;
            const containerWidth = container.width;
            const containerHeight = container.height;

            const scaleX = containerWidth / imageWidth;
            const scaleY = containerHeight / imageHeight;
            const zoom = Math.min(scaleX, scaleY);

            cropper?.zoomTo(zoom);
            initalZoomLevelRef.current = zoom;
        }
    };
    return (
        <>
            <Cropper
                src={src}
                style={{
                    width: "90%",
                    maxHeight: "65vh",
                    overflow: "hidden"
                }}
                initialAspectRatio={1}
                viewMode={1}
                autoCropArea={0.9}
                background={false}
                responsive={true}
                checkOrientation={false}
                guides={true}
                ref={cropperRef}
                ready={onReady}
                zoomTo={0.6}
                className="not-dragabble"
                crossOrigin="anonymous"
                minCropBoxHeight={10}
                minCropBoxWidth={10}
                dragMode="move"
                zoomable={true}
                movable={true}
            />
        </>
    );
};
